import { useEffect, useState } from 'react'
import { ProposalsProps } from 'lib/types'
import { getQuantityLabel } from 'lib/helpers'
import '../Proposal/proposal.scss'
import './print.scss'

const ProposalsPdf = ({ proposals }: IProps) => {
  const [proposalCalculationData, setProposalCalculationData] = useState(proposals?.calculationData?.data)
  const [proposalSiteDesignData, setProposalSiteDesignData] = useState(proposals?.siteDesignData)
  const [hasArchiving, setHasArchiving] = useState(false)
  const [hasManagementServer, setHasManagementServer] = useState(false)

  const archiving = proposalCalculationData?.archiveDatabase
  const genericManagementServer = proposalSiteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.addManagementServer

  useEffect(() => {
    if (proposals) {
      setProposalCalculationData(proposals.calculationData?.data)
      setProposalSiteDesignData(proposals.siteDesignData)
    }

    if (archiving) {
      setHasArchiving(true)
    } else {
      setHasArchiving(false)
    }

    if (genericManagementServer) {
      setHasManagementServer(true)
    } else {
      setHasManagementServer(false)
    }
  }, [proposals, archiving, genericManagementServer])

  return (
    <>
      <div className="px-10 ">
        <div className="msds-text-header-5 msds-text-clear-blue py-1">Proposal recommendation</div>
        <div className="msds-text-body-3 py-1 mt-1">Calculated from your selections.</div>
        <div className="msds-text-header-6 py-1">Recording Servers</div>
        <div className="row xsd-proposals-pdf">
          <div className={'col-4 xsd-proposals-pdf__server-setting-col-wrapper' + (hasArchiving ? ' mb-12' : '')}>
            <div className="xsd-proposals-pdf__server-setting-col">
              <div className="server-settings__header msds-text-header-3-bold">Recording Server Specification</div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info mt-1">
                <div>Quantity of servers:</div>
                <div>{proposalCalculationData?.genericProposal?.quantity}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>Camera Streams per server:</div>
                <div>{proposalCalculationData?.genericProposal?.camerasPrServer}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>Machine Type:</div>
                <div>{proposalCalculationData?.genericProposal?.machineType}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>CPU Type: </div>
                <div>{proposalCalculationData?.genericProposal?.cpuType}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>OS Disk: </div>
                <div>{proposalCalculationData?.genericProposal?.osDisk}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>RAM: </div>
                <div>{proposalCalculationData?.genericProposal?.ram}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>
                  OS Version please <a href="#osVersion">see information below</a>
                </div>
              </div>
            </div>
          </div>

          <div className={'col-4 xsd-proposals-pdf__server-setting-col-wrapper' + (hasArchiving ? ' mb-12' : '')}>
            <div className="xsd-proposals-pdf__server-setting-col">
              <div className="server-settings__header msds-text-header-3-bold">Live Database Storage Information</div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info mt-1">
                <div>{getQuantityLabel(proposalCalculationData?.liveDatabase?.connectivity)}:</div>
                <div>{proposalCalculationData?.liveDatabase?.quantity}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>Disk Type:</div>
                <div>{proposalCalculationData?.liveDatabase?.diskType}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>Disk Size:</div>
                <div> {proposalCalculationData?.liveDatabase?.diskSize}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>Raid Type:</div>
                <div>{proposalCalculationData?.liveDatabase?.raidType}</div>
              </div>
              <div className="msds-text-body-4-bold xsd-proposals-pdf__card-info">
                <div>Required Capacity:</div>
                <div>{proposalCalculationData?.liveDatabase?.reqCapacity}</div>
              </div>
              <div className="msds-text-body-4-bold xsd-proposals-pdf__card-info">
                <div>Formatted Capacity:</div>
                <div>{proposalCalculationData?.liveDatabase?.formattedCapacity}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>Connectivity:</div>
                <div>{proposalCalculationData?.liveDatabase?.connectivity}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>IOPS:</div>
                <div>{proposalCalculationData?.liveDatabase?.iops}</div>
              </div>
              <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                <div>Throughput:</div>
                <div>{proposalCalculationData?.liveDatabase?.transferSpeed}</div>
              </div>
            </div>
          </div>

          {/* {proposalCalculationData?.archiveDatabase && (
                        <div className="print-page-break col-12"></div>
                    )} */}

          {proposalCalculationData?.archiveDatabase && (
            <div
              className={
                'col-4 xsd-proposals-pdf__server-setting-col-wrapper' +
                (hasManagementServer && !hasArchiving ? ' mt-6 ' : '') +
                (hasArchiving && !hasManagementServer ? ' mt-12' : '') +
                (hasArchiving && hasManagementServer ? ' mt-8' : '')
              }>
              <div className="xsd-proposals-pdf__server-setting-col">
                <div className="server-settings__header msds-text-header-3-bold mt-1">Archive Database Storage Information</div>
                <div className="msds-text-body-3 xsd-proposals-pdf__card-info mt-1">
                  <div>{getQuantityLabel(proposalCalculationData?.archiveDatabase?.connectivity)}:</div>
                  <div>{proposalCalculationData?.archiveDatabase?.quantity}</div>
                </div>
                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                  <div>Disk Type:</div>
                  <div>{proposalCalculationData?.archiveDatabase?.diskType}</div>
                </div>
                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                  <div>Disk Size:</div>
                  <div>{proposalCalculationData?.archiveDatabase?.diskSize}</div>
                </div>
                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                  <div>Raid Type:</div>
                  <div>{proposalCalculationData?.archiveDatabase?.raidType}</div>
                </div>
                <div className="msds-text-body-4-bold xsd-proposals-pdf__card-info">
                  <div>Required Capacity:</div>
                  <div>{proposalCalculationData?.archiveDatabase?.reqCapacity}</div>
                </div>
                <div className="msds-text-body-4-bold xsd-proposals-pdf__card-info">
                  <div>Formatted Capacity:</div>
                  <div>{proposalCalculationData?.archiveDatabase?.formattedCapacity}</div>
                </div>
                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                  <div>Connectivity:</div>
                  <div>{proposalCalculationData?.archiveDatabase?.connectivity}</div>
                </div>
                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                  <div>IOPS:</div>
                  <div>{proposalCalculationData?.archiveDatabase?.iops}</div>
                </div>
                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                  <div>Throughput:</div>
                  <div>{proposalCalculationData?.archiveDatabase?.transferSpeed}</div>
                </div>
              </div>
            </div>
          )}
          {proposalCalculationData?.networkInterface && (
            <div
              className={
                'col-4 xsd-proposals-pdf__server-setting-col-wrapper' +
                (hasManagementServer && !hasArchiving ? ' mb-6' : '') +
                (hasArchiving && !hasManagementServer ? ' mt-12' : '') +
                (hasArchiving && hasManagementServer ? ' mt-8' : '')
              }>
              <div className="xsd-proposals-pdf__server-setting-col">
                <div className="server-settings__header msds-text-header-3-bold mt-1">Network Interface</div>
                {proposalCalculationData?.networkInterface?.map((network, index) => (
                  <div key={index}>
                    <div className="msds-text-body-4-bold xsd-proposals-pdf__card-info mt-1">
                      <div>Usage: </div>
                      <div>{network?.usage}</div>
                    </div>
                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                      <div>Speed: </div>
                      <div>{network?.speed}</div>
                    </div>
                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                      <div>Required Bitrate: </div>
                      <div>{network?.requiredBitrate}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
interface IProps {
  proposals: ProposalsProps
}

export default ProposalsPdf
